import * as React from 'react';

export function WorkspaceMembersTableWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className={'w-full relative'} style={{ marginTop: '20px' }}>
      {children}
    </div>
  );
}
